import Modal from "./Modal";

export * from "./LinkModal";
export * from "./WarningModal";
export default Modal;
